

// These codes are the internal codes used to identify supported languages in Mimir.
// 'unknown' is used when the transcript is received from an external system without an associated language code.

export const LanguageCodes = <const> [
  'af-ZA', 'am-ET', 'ar-AE', 'ar-AR', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IL', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-MA', 'ar-OM',
  'ar-PS', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'az-AZ', 'bg-BG', 'bn-BD', 'bn-IN', 'ca-ES', 'cs-CZ', 'da-DK', 'de-AT', 'de-CH',
  'de-DE', 'el-GR', 'en-AU', 'en-AB', 'en-CA', 'en-GH', 'en-HK', 'en-IE', 'en-IN', 'en-KE', 'en-NG', 'en-NZ', 'en-PH', 'en-SG',
  'en-TZ', 'en-UK', 'en-US', 'en-WL', 'en-ZA', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-CU', 'es-DO', 'es-EC', 'es-ES',
  'es-GQ', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-PY', 'es-SV', 'es-US', 'es-UY', 'es-VE', 'et-EE',
  'eu-ES', 'fa-IR', 'fi-FI', 'fr-CA', 'fr-CH', 'fr-FR', 'ga-IE', 'gl-ES', 'gu-IN', 'he-IL', 'hi-IN', 'hr-HR', 'hu-HU', 'hy-AM',
  'id-ID', 'is-IS', 'it-IT', 'ja-JP', 'jv-ID', 'ka-GE', 'km-KH', 'kn-IN', 'ko-KR', 'lo-LA', 'lt-LT', 'lv-LV', 'ml-IN', 'mr-IN',
  'ms-MY', 'mt-MT', 'nb-NO', 'ne-NP', 'nl-BE', 'nl-NL', 'pl-PL', 'pt-BR', 'pt-PT', 'ro-RO', 'ru-RU', 'si-LK', 'sk-SK', 'sl-SI',
  'sr-RS', 'su-ID', 'sv-SE', 'sw-KE', 'sw-TZ', 'ta-IN', 'ta-LK', 'ta-MY', 'ta-SG', 'te-IN', 'th-TH', 'tr-TR', 'uk-UA', 'ur-IN',
  'ur-PK', 'vi-VN', 'zh-CN', 'zh-HK', 'zh-TW', 'zu-ZA', 'fil-PH', 'zh2-HK', 'sq-AL', 'ar-LY', 'ar-YE', 'bs-BA', 'my-MM', 'en-PK',
  'fr-BE', 'it-CH', 'kk-KZ', 'mk-MK', 'mn-MN', 'pa-Guru-IN', 'uz-UZ', 'be-BY', 'ba-RU', 'eo-EO', 'ia-IA', 'ug-CN', 'auto', 'unknown',
];

export type LanguageCode = typeof LanguageCodes[number];

export const TrintTranscriptionService = 'trintSpeechToText';

// The supported speech-to-text services
export const TranscriptionServices = <const> [
  'awsTranscribe',
  'googleSpeechToText',
  'ibmSpeechToText',
  'msSpeechToText',
  'zoomSpeechToText', // Now shown in the UI as Scriptix
  'speechmaticsSpeechToText',
  TrintTranscriptionService,
  'amberscriptSpeechToText',
  'recapp2SpeechToText',
  'srtImport',
];

export type TranscriptionService = typeof TranscriptionServices[number];

export type AsyncOperationStateValue = (
  'progressing' |
  'complete' |
  'error' |
  'initiated' |
  'canceled'
);
